// pages/admin/AdminPanel.js
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import AdminUsers from './AdminUsers';
import AdminInheritances from './AdminInheritances';
import AdminActivityLogs from './AdminActivityLogs';
import AdminSettings from './AdminSettings';
import AdminSidebar from './components/AdminSidebar';
import AdminNotifications from './components/AdminNotifications';
import './AdminPanel.css';

const AdminPanel = () => {
  const { isAuthenticated, currentPage, setCurrentPage } = useAdmin();
  const [sidebarVisible, setSidebarVisible] = useState(window.innerWidth >= 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const location = useLocation();
  const navigate = useNavigate();

  // Handle responsive layout
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      setSidebarVisible(mobile ? false : true);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Update current page based on route
  useEffect(() => {
    const path = location.pathname.split('/')[2] || 'dashboard';
    setCurrentPage(path);
  }, [location.pathname, setCurrentPage]);

  // Handle navigation
  const handleNavigation = (page) => {
    navigate(`/admin/${page}`);
    if (isMobile) {
      setSidebarVisible(false);
    }
  };

  // Toggle sidebar
  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  if (!isAuthenticated) {
    return <AdminLogin />;
  }

  return (
    <div className="admin-panel">
      <AdminSidebar 
        visible={sidebarVisible}
        currentPage={currentPage}
        onNavigate={handleNavigation}
        onToggle={toggleSidebar}
        isMobile={isMobile}
      />
      
      <div className={`admin-main-content ${sidebarVisible ? 'sidebar-open' : ''}`}>
        <div className="admin-top-bar">
          <div className="hamburger-menu" onClick={toggleSidebar}>
            <i className="fas fa-bars"></i>
          </div>
        </div>

        <div className="admin-page-content">
          <Routes>
            <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/users" element={<AdminUsers />} />
            <Route path="/inheritances" element={<AdminInheritances />} />
            <Route path="/activity" element={<AdminActivityLogs />} />
            <Route path="/settings/*" element={<AdminSettings />} />
            <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
          </Routes>
        </div>
      </div>

      <AdminNotifications />
    </div>
  );
};

export default AdminPanel;